import _ from 'lodash';
import config from '~/config';
import fs from 'fs-extra';
import path from 'path';
import Promise from 'bluebird';
import { log } from '@swiper/core';
import cache from 'memory-cache';
import { EventEmitter } from 'events';

import { Service } from './Service';

const control = new EventEmitter();

export class DataFilesService extends Service {

  constructor( opts ) {
    super( opts );
    _.defaults( this, {
      cache   : false,
    } );
    if ( ! this.dir ) this.dir = config.dir( this.name );
    this._cache = Object.create( null );
    control.on( 'cache-clear', () => this.cache_clear() );
  }

  pathto( ...args ) {
    const file = path.resolve( this.dir, ...args );
    console.log( 'FILE', file );
    if ( ! file.endsWith( '.json' ) ) return file + '.json';
    return file;
  }

  cache_get( key ) {
    if ( ! this.cache ) return;
    if ( ! this._cache[ key ] ) return;
    return this._cache[ key ].value;
  }

  cache_put( key, value, meta={} ) {
    if ( ! this.cache ) return;
    this._cache[ key ] = { ...meta, value };
    return value;
  }

  cache_meta( key ) {
    if ( ! this.cache ) return;
    if ( ! this._cache[ key ] ) return;
    return _.omit( this._cache[ key ], 'value' );
  }

  cache_clear() {
    if ( ! this.cache ) return;
    this._cache = Object.create( null );
  }

  async read( file ) {
    const cached = this.cache_get( file );
    if ( cached ) return cached;
    const text = await fs.readFile( file, 'utf8' );
    const data = JSON.parse( text );
    this.cache_put( file, data );
    return data;
  }

  async write( file, data ) {
    const text = JSON.stringify( data, null, 2 );
    await fs.outputFile( file, text, 'utf8' );
    this.cache_put( file, data );
    cache.del( file );
  }

  async list() {
    return fs.readdir( this.dir ).then( files => {
      return _.compact( _.map( files, file => {
        if ( ! file.endsWith( '.json' ) ) return;
        return path.basename( file, '.json' );
      } ) );
    } );
  }

  async exists( id ) { return fs.exists( this.pathto( id ) ); }

  async get( id, params ) {
    try {
      const data = await this.read( this.pathto( id ) );
      return data;
    } catch( err ) {
      if ( err.code === 'ENOENT' ) {
        this.throw( 'NotFound', `ID "${id}" not found in ${this.name}` );
      } else {
        this.throw( 'GeneralError', err );
      }
    }
  }

  async find( { query, ...params } ) {
    return this.filter( query );
  }

  transformQuery( query ) {
    if ( _.isFunction( query ) ) return query;
    return _.iteratee( query );
  }

  async filter( matcher ) {
    matcher = this.transformQuery( matcher );
    return Promise.map( this.list(), async id => {
      const data = await this.get( id );
      if ( matcher( data ) ) {
        console.log( 'MATCHED', id );
        return data;
      } else {
        console.log( 'NOMATCH', id );
        return;
      }
    } ).filter( Boolean );
  }

  // TODO - For now these are all read-only
  async create( data, params ) {
    this.throw( 'NotImplemented' );
    /*
    if ( ! data.id ) this.throw( 'BadRequest',`Cannot create without id` );
    if ( await this.exists( data.id ) ) {
      this.throw( 'Conflict', `Cannot create ${data.id}: it already exists` );
    }
    return this.write( this.pathto( data.id ), data );
    */
  }

  async update( id, data, params ) {
    this.throw( 'NotImplemented' );
    /*
    return this.write( this.pathto( data.id ), data );
    */
  }

  async patch( id, data, params ) {
    this.throw( 'NotImplemented' );
    /*
    const record = await this.get( id );
    _.assign( record, data );
    return this.write( this.pathto( data.id ), record );
    */
  }

  async remove( id, params ) {
    this.throw( 'NotImplemented' );
    /*
    return fs.unlink( this.pathto( id ) );
    */
  }

}
